module.exports = __webpack_public_path__ + "static/media/icon-cupon-redimible.d75ae87c.svg";